import { BaseValidator } from '../core/BaseValidator.js';
import { ValidationResult } from '../core/ValidationResult.js';

/**
 * Portuguese Citizen Card validator following Single Responsibility Principle
 */
export class PtValidator extends BaseValidator {
  constructor() {
    super({
      name: 'Portuguese Citizen Card',
      pattern: /^\d{8}\s?\d{1}\s?[A-Z]{2}\d{1}$/i,
      length: 12
    });
  }

  validateFormat(id) {
    const cleanId = id.replace(/\s/g, '');
    const upperCaseId = cleanId.toUpperCase();
    
    // Check length
    const lengthValidation = this.validateLength(upperCaseId, this.config.length);
    if (!lengthValidation.isValid) {
      return lengthValidation;
    }

    // Check pattern
    return this.validateRegex(
      id,
      this.config.pattern,
      'Portuguese Citizen Card format must be XXXXXXXX X XXX'
    );
  }

  validateChecksum(id) {
    const cleanId = id.replace(/\s/g, '').toUpperCase();
    const digits = cleanId.substring(0, 8);
    const checkDigit = parseInt(cleanId[8]);
    
    // Calculate checksum
    let sum = 0;
    for (let i = 0; i < 8; i++) {
      sum += parseInt(digits[i]) * (9 - i);
    }
    
    const expectedChecksum = 11 - (sum % 11);
    const finalChecksum = expectedChecksum >= 10 ? 0 : expectedChecksum;
    
    if (finalChecksum !== checkDigit) {
      return ValidationResult.invalid(`Invalid Portuguese Citizen Card checksum. Expected: ${finalChecksum}, Got: ${checkDigit}`);
    }

    return ValidationResult.valid('Valid Portuguese Citizen Card');
  }
}